/* eslint-disable react/jsx-props-no-spreading */
import { Col, Row, Form, Select, Input, Button, Divider, Tag } from 'antd';
import { useSelector } from 'react-redux';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { BENEFICIADOS } from 'constants/nombresCatalogos';
import { DeleteOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Accordion, AddButton, SimpleNumericInput } from 'components';
import '../../../../Formulario.scss';
import { groupObjectsByProperty } from 'utils/groupObjectsByProperty';
import * as fieldMsgs from 'constants/formFieldsMessages';

const getTiposAsociacionPorProcesoEspecifico = (
  listaBeneficiadosCompleta,
  procesoEspecificoId
  // catProcesosEspecificos
) => {
  const listaBeneficiados = listaBeneficiadosCompleta.filter(
    (beneficiado) => beneficiado.idProcesoSIMAC === procesoEspecificoId
  );
  const asociaciones = groupObjectsByProperty(listaBeneficiados, 'tipoAsociacion');
  return Object.keys(asociaciones).map((tipoAsociacion) => {
    return {
      tipoAsociacion,
      idTipoAsociacion: asociaciones[tipoAsociacion][0].idTipoAsociacion,
      beneficiarios: asociaciones[tipoAsociacion]
    };
  });
};

const DesignadosSO = ({ form }) => {
  const catBeneficiados = useSelector(selectCatalogByName(BENEFICIADOS));

  // Construir catalogo de sujetos obligados desde el catálogo de beneficiados.
  const catSujetosObligados = [];
  for (let i = 0; i < catBeneficiados.length; i += 1) {
    const objetoABuscar = {
      idSujetoObligado: catBeneficiados[i].idSujetoObligado,
      sujetoObligado: catBeneficiados[i].sujetoObligado
    };
    if (
      !catSujetosObligados.some((item) => JSON.stringify(item) === JSON.stringify(objetoABuscar))
    ) {
      catSujetosObligados.push(objetoABuscar);
    }
  }

  const formComponent = ({ remove, name, disabled, isLastHallazgo, ...restField }) => (
    <div>
      <div style={{ marginBottom: '10px' }}>
        <span
          className="instruction-span-purple"
          style={{ marginBottom: '2px', paddingLeft: '6px' }}>
          <span style={{ color: 'red', fontSize: '14px' }}>*</span>
          Completa la información solicitada del designado por el sujeto obligado para realizar el
          registro correctamente.
        </span>
      </div>
      <div className="formulario-hallazgos">
        <Row gutter={24}>
          <Col xs={22} className="formulario-hallazgos-tabla-header">
            Información del designado:
          </Col>
          <Col xs={2} style={{ textAlign: 'center' }} className="formulario-hallazgos-tabla-header">
            Acciones
          </Col>
        </Row>
        <Row>
          <Col xs={22} className="hallazgos-detalle">
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={6}>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, curValues) => {
                    return prevValues.idProcesoEspecifico !== curValues.idProcesoEspecifico;
                  }}>
                  {() => {
                    const { idProcesoEspecifico } = form.getFieldsValue(['idProcesoEspecifico']);
                    const tiposAsociacionPorProcesoEspecifico =
                      getTiposAsociacionPorProcesoEspecifico(catBeneficiados, idProcesoEspecifico);
                    return (
                      <Form.Item
                        {...restField}
                        name={[name, 'idTipoAsociacion']}
                        label="Tipo de asociación:">
                        <Select
                          placeholder="Selecciona..."
                          fieldNames={{
                            value: 'idTipoAsociacion',
                            label: 'tipoAsociacion'
                          }}
                          options={tiposAsociacionPorProcesoEspecifico}
                          filterOption={(inputValue, option) =>
                            option.tipoAsociacion
                              ?.toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          showSearch
                        />
                      </Form.Item>
                    );
                  }}
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  {...restField}
                  name={[name, 'idSujetoObligado']}
                  label="Sujeto Obligado:">
                  <Select
                    placeholder="Selecciona..."
                    fieldNames={{
                      value: 'idSujetoObligado',
                      label: 'sujetoObligado'
                    }}
                    options={catSujetosObligados}
                    filterOption={(inputValue, option) =>
                      option.sujetoObligado?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={[name, 'numeroEscrito']} label="Número de escrito:">
                  <SimpleNumericInput placeholder="Escribe..." />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={[name, 'nombre']} label="Nombre:">
                  <Input placeholder="Escribe..." />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={6}>
                <Form.Item
                  className=""
                  name={[name, 'puesto']}
                  label="Puesto:"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input placeholder="Escribe..." />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col xs={2}>
            <div className="hallazgos-imagenes-acciones">
              <Button disabled={isLastHallazgo} style={{ height: '2em' }}>
                <DeleteOutlined onClick={() => remove(name)} />
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );

  return (
    <div className="modal-monitoreo-internet-hallazgos">
      <Row gutter={[24, 0]} className="row-formulario" style={{ marginBottom: '11px' }}>
        <Col span={24} className="col-dos-instrucciones">
          <span className="instruction-span-purple" style={{ paddingLeft: '9px' }}>
            Agrega los registros necesarios.
          </span>
          <Tag
            className="instruction-span-pink"
            icon={<ExclamationCircleFilled style={{ fontSize: '10px' }} />}
            bordered={false}
            color="magenta"
            style={{ marginBottom: '6px', paddingLeft: '9px' }}>
            El registro de designados por el sujeto obligado es opcional. Si realizas el registro
            completa todos los campos solicitados.
          </Tag>
        </Col>
      </Row>
      <Form layout="vertical" form={form}>
        <Form.List name="designados" initialValue={[{}]}>
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, ...restField }) => {
                  const isLastHallazgo = fields.length <= 1;

                  const designado = {
                    key: `designado_${key}`,
                    label: `Designado ${name + 1}`,
                    forceRender: true,
                    children: formComponent({
                      remove,
                      name,
                      isLastHallazgo,
                      ...restField
                    })
                  };
                  return (
                    <Accordion key={key} items={[designado]} defaultActiveKey={['designado_0']} />
                  );
                })}
                <Divider />
                <div className="formulario-hallazgos-acciones">
                  <AddButton
                    onClick={() => {
                      add();
                    }}
                    style={{ marginRight: '1em' }}>
                    Agregar Nuevo
                  </AddButton>
                </div>
              </>
            );
          }}
        </Form.List>
      </Form>
    </div>
  );
};

DesignadosSO.propTypes = {
  form: PropTypes.shape({ getFieldsValue: PropTypes.func }).isRequired
};

export default DesignadosSO;
